( function() {

	document.addEventListener("DOMContentLoaded", function()
    {
        setupReadMoreBlocks();
    });



    function setupReadMoreBlocks()
    {
        document.querySelectorAll('.extra-content').forEach((extra) => {
            
            rmBlock = findAncestor(extra, '.readmore-block');
            // console.log(rmBlock);
            
            extra.addEventListener('show.bs.collapse', function (event) {
                this.classList.add("open");
                this.classList.remove("close");
                // console.log("Read More Blocks");


                if(rmBlock)
                {
                    rmBlock.classList.add("open");
                    rmBlock.classList.remove("close");
                }
                console.log('show.bs.collapse', this, event, rmBlock);
            })
            
            extra.addEventListener('hide.bs.collapse', function (event) {
                this.classList.remove("open");
                this.classList.add("close");

                if(rmBlock)
                {
                    rmBlock.classList.remove("open");
                    rmBlock.classList.add("close");
                }
                console.log('hide.bs.collapse', this, event, rmBlock);
            })
        });
    }

}() );